var React = require('react');

function InlineSvg (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1251_20356)","key":0},[React.createElement("rect",{"x":"12","y":"12","width":"12","height":"12","fill":"white","key":0}),React.createElement("rect",{"y":"12","width":"12","height":"12","fill":"#CCD0D5","key":1}),React.createElement("rect",{"x":"12","width":"12","height":"12","fill":"#CCD0D5","key":2}),React.createElement("rect",{"width":"12","height":"12","fill":"white","key":3})]),React.createElement("rect",{"x":"0.5","y":"0.5","width":"23","height":"23","rx":"11.5","stroke":"#CCD0D5","key":1}),React.createElement("defs",{"key":2},React.createElement("clipPath",{"id":"clip0_1251_20356"},React.createElement("rect",{"width":"24","height":"24","rx":"12","fill":"white"})))]);
}

InlineSvg.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = InlineSvg;

InlineSvg.default = InlineSvg;
